import { IsIn, IsString, IsOptional } from 'class-validator';

export class SystemTaskDto {
  @IsIn(['SystemTask'])
  type: 'SystemTask';

  @IsString()
  @IsOptional()
  stageName: string;
}
